import { ColumnFilter } from './ColumnFilter.js'

//The framework for table creation for the resource constraints.
export const ColumnNames = [
    {
        Header: 'PO Number',
        accessor: 'po_number',
        Filter: ColumnFilter,
    },
    {
        Header: 'Start Date',
        accessor: 'constraint_startdate',
        Cell: ({value})=>{ if (value === null) {return ''} else{return value} },
        Filter: ColumnFilter,
    },
    {
        Header: 'End Date',
        accessor: 'constraint_enddate',
        Cell: ({value})=>{ if (value === null) {return ''} else{return value} },
        Filter: ColumnFilter,
    },

    {
        Header: 'Maximum Hours',
        accessor: 'hours_max',
        Filter: ColumnFilter
        
    },

    {
        Header: "Hours Worked",
        accessor: "hours_worked",
        Filter: ColumnFilter
    },
    {
        Header:()=>null,
        id: 'edit',
        Filter: ColumnFilter,
    },
]